//import store from "../../store";
const unternehmenRoutes = [
  {
    path: "/Unternehmen",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/Unternehmen.vue"
      ), 
      
  },
];

export default unternehmenRoutes;
